/**
 * Formats duration in seconds to a human-readable time string
 * @param seconds - The duration in seconds
 * @returns Formatted string in MM:SS, HH:MM:SS, or D:HH:MM:SS format
 *
 * @example
 * formatDuration(90)      // "01:30"
 * formatDuration(3665)    // "1:01:05"
 * formatDuration(90000)   // "1:01:00:00"
 */
export const formatDuration = (seconds: number): string => {
  const roundedSeconds = Math.round(seconds);

  if (roundedSeconds < 60) {
    // Less than a minute: "0:SS"
    return `0:${String(roundedSeconds).padStart(2, "0")}`;
  }

  const days = Math.floor(roundedSeconds / 86400);
  const hours = Math.floor((roundedSeconds % 86400) / 3600);
  const minutes = Math.floor((roundedSeconds % 3600) / 60);
  const secs = roundedSeconds % 60;

  if (days > 0) {
    // D:HH:MM:SS format
    return `${days}:${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  }

  if (hours > 0) {
    // HH:MM:SS format
    return `${hours}:${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  }

  // MM:SS format
  return `${minutes}:${String(secs).padStart(2, "0")}`;
};
